import { CSSProperties, FC } from "react"
import classes from "./styles.module.scss"
import { classNames } from "@/shared/lib/helpers/classNames"

interface LogoProps {
	src: string
	alt?: string
	size?: "sm" | "md" | "lg"
	rootStyles?: CSSProperties
	contentStyles?: CSSProperties
}

export const Logo: FC<LogoProps> = ({ src, alt, size = "md", rootStyles, contentStyles }) => {
	return (
		<div className={classNames([classes.container, classes[size]])} style={rootStyles}>
			<img
				src={src}
				className={classes.logo}
				alt={alt ? alt : "Логотип компании в шапке сайте"}
				style={contentStyles}
			/>
		</div>
	)
}
